import { Listbox as HeadlessListbox } from "@headlessui/react";
import React from "react";
import { joinClasses } from "../../utils/joinClasses";
export const ListboxOptions = ({ className, ...props }) => (React.createElement(HeadlessListbox.Options, { as: "div", className: joinClasses(["nxm-dropdown-items", className]), ...props }));
